/*! @azure/msal-common v13.1.0 2023-06-07 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "13.1.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
